function onPageShow() {
	if (pageTransitionEnabled && pageTransition && pageTransition.entered) {
		pageTransition.enter(function () {
			$(window).trigger('transitionDone');
		});
	}else{
		$(window).trigger('transitionDone');
	}
}
